export { LocalStorage, SessionStorage } from './web-storage.decorator';
